import { Box, Stack, Title, Flex, Image, Grid, Col, Text, Modal } from '@mantine/core';
import { useEffect, useState } from 'react';
import loading from 'assets/report/loading.gif';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { API } from 'services';
import { notifications } from 'notifications';

export function TimesheetDetails() {
  const [isLoading, setLoading] = useState(false);
  const [isPdfModal, setIsPdfModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState('');
  const [pdfName, setPdfName] = useState('');
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const timesheet_id = queryParams.get('timesheet_id');

  useEffect(() => {
    // prevent horizontal scroll back and forward navigation
    // because our datatable require horizontal scroll alots
    const cached = document.body.style.overscrollBehaviorX;
    document.body.style.overscrollBehaviorX = 'none';
    return () => {
      document.body.style.overscrollBehaviorX = cached;
    };
  }, []);

  // Update height on window resize
  useEffect(() => {
    const updateHeight = () => {
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener('resize', updateHeight);

    // Cleanup the event listener when component unmounts
    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  const courseDetail = useQuery(
    ['timesheetdetail', timesheet_id],
    () => {
      if (!timesheet_id) throw new Error('Timesheet ID is required');
      setLoading(true);
      return API.getTimesheetDetails({
        timesheet_id: timesheet_id,
      })
        .then((res) => {
          setLoading(false);
          return res.data;
        })
        .catch((error) => {
          setLoading(false);
          throw error;
        });
    },
    {
      enabled: !!timesheet_id,
    }
  );

  return (
    <Stack px={{ base: 0, md: 30 }}>
      {isLoading && (
        <Box className={'loading_box'}>
          <Image src={loading} width="100"></Image>
        </Box>
      )}
      <Flex className={'flex_wrap'}>
        <Box className={'w100 md_w100'}>
          <Box bg="#FFF" p={20}>
            <Box mb={20} className="flex flex_direction_row flex_align_center flex_justify_between">
              <Title order={2}>Timesheet Details</Title>
            </Box>
            {!isLoading &&
              courseDetail &&
              courseDetail.data &&
              courseDetail.data.TrainerTimesheet && (
                <Box>
                  <Flex
                    w="100%"
                    p={20}
                    my={10}
                    direction="row"
                    wrap="wrap"
                    style={{ backgroundColor: '#f2fbf9' }}
                  >
                    <Title order={4} my={10} w="100%">
                      Timesheet Information
                    </Title>
                    <hr style={{ width: '100%', borderTop: '1px solid', borderColor: '#ddd' }}></hr>
                    <Box mt={20} w="100%">
                      <Grid>
                        <Col span={12}>
                          <Grid>
                            <Col span={6}>
                              <Text weight={500}>Date:</Text>
                              <Text>
                                {courseDetail.data.TrainerTimesheet.trainertimesheet_date}
                              </Text>
                            </Col>
                            <Col span={6}>
                              <Text weight={500}>Course ID:</Text>
                              <Text>{courseDetail.data.TrainerTimesheet.course_title}</Text>
                            </Col>
                            <Col span={6}>
                              <Text weight={500}>Course Run ID:</Text>
                              <Text>
                                {courseDetail.data.TrainerTimesheet.courserun_apicourserunid ||
                                  'N/A'}
                              </Text>
                            </Col>
                            <Col span={6}>
                              <Text weight={500}>No. of Assessment:</Text>
                              <Text>
                                {
                                  courseDetail.data.TrainerTimesheet
                                    .trainertimesheet_assessment_count
                                }
                              </Text>
                            </Col>
                            <Col span={6}>
                              <Text weight={500}>Sign In COA:</Text>
                              <Text>
                                {courseDetail.data.TrainerTimesheet.trainertimesheet_sign_in_coa}
                              </Text>
                            </Col>
                            <Col span={6}>
                              <Text weight={500}>No. of Hours Worked:</Text>
                              <Text>
                                {courseDetail.data.TrainerTimesheet.trainertimesheet_working_hrs}
                              </Text>
                            </Col>
                            <Col span={6}>
                              <Text weight={500}>Sign Out COA:</Text>
                              <Text>
                                {courseDetail.data.TrainerTimesheet.trainertimesheet_sign_out_coa}
                              </Text>
                            </Col>
                            <Col span={6}>
                              <Text weight={500}>Status:</Text>
                              <Text>
                                {courseDetail.data.TrainerTimesheet.trainertimesheet_status}
                              </Text>
                            </Col>
                            {courseDetail.data.TrainerTimesheet.trainertimesheet_remark && (
                              <Col span={12}>
                                <Text weight={500}>Remarks:</Text>
                                <Text>
                                  {courseDetail.data.TrainerTimesheet.trainertimesheet_remark}
                                </Text>
                              </Col>
                            )}
                          </Grid>
                        </Col>
                      </Grid>
                    </Box>
                  </Flex>
                </Box>
              )}
            <Box></Box>
          </Box>
        </Box>
      </Flex>
      <Modal
        opened={isPdfModal}
        onClose={() => setIsPdfModal(false)}
        title={pdfName}
        size="xl"
        fullScreen
      >
        {/* PDF Viewer (Iframe) */}
        <iframe
          src={pdfUrl}
          width="100%"
          height={screenHeight - 100}
          title="PDF Viewer"
          style={{ border: 'none' }}
        />
      </Modal>
    </Stack>
  );
}
